import { useEffect } from "react";

export const useClickOutside = (id, onClickOutside, onClickInside) => {
  useEffect(() => {
    const fn = (e) => {
      const domnode = document.getElementById(id);
      if (
        e.clientX < domnode?.offsetLeft - 5 ||
        e.clientY < domnode?.offsetTop - 5 ||
        e.clientX > domnode?.offsetWidth + domnode.offsetLeft + 5 ||
        e.clientY > domnode.offsetHeight + domnode.offsetTop + 5
      ) {
        onClickOutside?.(e);
      } else {
        onClickInside?.(e);
      }
    };
    document.addEventListener("click", fn);
    return () => {
      document.removeEventListener("click", fn);
    };
  });
};
